import { removePluralOverrides } from '@shared/translation/textTree';
import env from '@/util/env';
import type { AllTexts } from './types';

export const fallbackLanguage = 'en';
export const showTextKeysLanguage = 'en-x-code';

export const getFallbackTranslations = (devTranslations: {
  default: AllTexts;
}) => ({ default: removePluralOverrides(devTranslations.default) });

export const getDefaultLanguage = () =>
  env.DEFAULT_LANGUAGE ?? fallbackLanguage;

export const getRequestLanguage = () => {
  if (sessionStorage.getItem('settings.showTextKeys') === 'true') {
    return showTextKeysLanguage;
  }

  const storedLanguage = localStorage.getItem('settings.language');
  if (storedLanguage) {
    try {
      return JSON.parse(storedLanguage);
    } catch {
      return getDefaultLanguage();
    }
  }

  return getDefaultLanguage();
};

// We don't want any fallbacks for plural forms "zero" and "one", as those doesn't exist
// in all languages. Instead we should keep only plural form "other" as a fallback!
export const removePluralForms = removePluralOverrides;
